// extracted by mini-css-extract-plugin
export default {"partner":"Partner_partner__CmzxM","image":"Partner_image__ehQzj","thanks":"Partner_thanks__O2Hmf"};